<template>
  <!-- TODO: Remove v-text-field -->
  <!-- PARENT MUST HANDLE EMIT "search" -->
  <div
    class="dynamic-search-bar"
    :style="`
      max-width:${max_width ? max_width + 'px' : ''};
      min-height:${min_height || 32}px;
      max-height:${max_height || 32}px;
    `"
    @mouseover="search_is_hovered=true"
    @mouseleave="search_is_hovered=false"
  >
    <div
      v-if="underscored"
      class="dynamic-search-bar-underscored-container"
    >
      <div
        class="dynamic-search-bar-underscored"
        :style="`
          ${(search_is_focused || search_is_hovered)
            ? `border-color: ${color};`
            : `border-color: ${getTranspHexColor(color, .7)};`}
          margin-top: ${(min_height || 32) + 1}px;
        `"
      >
        <transition name="focus-search">
          <div
            v-if="search_is_focused"
            :style="`border-color: ${color};`"
            class="dynamic-search-bar-underscored-focused"
          />
        </transition>
      </div>
    <!-- ${search_is_focused
      ? 'border-width: 2px;'
      : 'border-width: 1px;'} -->
    </div>
    <v-text-field
      :class="underscored ? 'dynamic-search-bar-no-padding' : ''"
      v-model="search_term"
      :outlined="!underscored"
      clearable
      clear-icon="close"
      :placeholder="placeholder || 'Search' /* TODO: needs to be dynamic */"
      rounded
      dense
      hide-details
      :light="is_light_mode(color)"
      :color="color"
      :height="(min_height || 32) - 6"
      :disabled="is_disabled"
      @focus="search_is_focused=true"
      @blur="search_is_focused=false"
      @input="is_live_emit ? inputEvent(search_term) : ''"
      @keydown.enter="$emit('search', search_term || '')"
    >
      <button slot="append" @click="$emit('search', search_term || '')">
        <TIcon
          slot="append"
          name="magnifying-glass"
          :color="
            (search_is_focused || search_is_hovered || underscored)
              ? color
              : getTranspHexColor(color, .5)
            "
        />
      </button>
    </v-text-field>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    components: {
      TIcon,
    },

    mixins: [
      TColor,
    ],

    props: [
      'max_width', // is number, controls max-width of search bar
      'min_height', // is number, controls min-height of search bar
      'max_height', // is number, controls max-height of search bar
      'is_live_emit', // is boolean, controls wether search bar emits on every key change
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'placeholder', // is string, contains displayed placeholder
      'is_disabled', // is boolean, controls wether the searchbar is disabled or not
      /* NOTE: computed properties (no value needed) */
      // underscored // is boolean, toggle this
    ],

    data: () => ({
      search_is_focused: false,
      search_is_hovered: false,
      search_term: '',

      delta_foreground_color: '',
      delta_light_mode: '',
    }),

    computed: {
      color() {
        return this.getColor(this.foreground_color);
      },

      underscored() {
        let a = this.$attrs;
        if(a.underscored !== undefined) {
          if(a.underscored || a.underscored === '')
            { return true; } }
        return false;
      },
    },

    methods: {
      inputEvent(search_term){
        let self = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          self.$emit('search', search_term || '');
        }, 1000);
      }
    }
  }
</script>

<style>
  .dynamic-search-bar {
    flex-grow: 1;
    position: relative;
  }
  .dynamic-search-bar-icon {
    display: flex;
    align-items: center;
  }
  .dynamic-search-bar-no-padding > .v-input__control > .v-input__slot {
    padding: 0 !important;
  }
  .dynamic-search-bar-underscored-container {
    width: 100%;
    height: 100%;
    display: flex;
    position: absolute;
    align-items: flex-end; /* fix for Underline*/
    justify-content: center;
    top: 0;
  }
  .dynamic-search-bar-underscored {
    width: 100%;
    /* height: 0; */
    border-top: 1px solid white;
    transition: border-color 0.2s ease-in-out;
    /* position: relative; fix for Underline */
    /* display: flex; fix for Underline */
    /* justify-content: center; fix for Underline */
  }
  .dynamic-search-bar-underscored-focused {
    border-top: 1px solid white;
    width: 100%;
  }
  .focus-search-enter-active, .focus-search-leave-active {
    transition: all .33s ease-in-out;
    overflow: hidden;
  }
  .focus-search-enter, .focus-search-leave-to {
    width: 0%;
  }
</style>
